import { Switch } from "antd";
import React from "react";
import styled from "styled-components";

const StyledSwitch = styled(Switch)`
  &.ant-switch {
    min-width: 40px;
    height: 20px;
    background-color: ${({ theme }) => theme.COLORS.PrimaryBorder};

    &.ant-switch-checked {
      background: #007aff !important;
    }

    .ant-switch-handle {
      width: 16px;
      height: 16px;
      top: 2px;

      &::before {
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }
    }

    &.ant-switch-checked .ant-switch-handle {
      inset-inline-start: calc(100% - 18px);
    }

    &:hover:not(.ant-switch-disabled) {
      background-color: ${({ theme }) => theme.COLORS.PrimaryBorder}dd;

      &.ant-switch-checked {
        background: #007aff !important;
        opacity: 0.9;
      }
    }
  }
`;

const CSwitch = ({ checked, setChecked, action, style = {} }: any) => {
  return (
    <StyledSwitch
      checked={checked}
      onChange={() => {
        if (setChecked) {
          setChecked(!checked);
        }
        if (action) {
          action(checked);
        }
      }}
      style={style}
    />
  );
};

export default React.memo(CSwitch);
